import * as React from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { v4 as uuid } from "uuid";
import { Sync } from "src/database/sync";

export type MetricSeriesEntity = Extract<
  Parameters<typeof Sync.upsert>[0],
  { type: "metric_series" }
>;

const VALUE_TYPES: { value: "deci" | "int"; label: string }[] = [
  { value: "deci", label: "Decimal" },
  { value: "int", label: "Integer" },
];

interface Props {
  show: boolean;
  onHide(): void;
  onSave(series: MetricSeriesEntity): void;
}

export function MetricSeriesModal({ show, onHide, onSave }: Props) {
  const [label, setLabel] = React.useState("");
  const [valueType, setValueType] = React.useState<"deci" | "int">("deci");

  React.useEffect(() => {
    if (show) {
      setLabel("");
      setValueType("deci");
    }
  }, [show]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = label.trim();
    if (!trimmed) {
      return;
    }
    const series: MetricSeriesEntity = {
      type: "metric_series",
      id: uuid(),
      label: trimmed,
      valueType,
    };
    await Sync.upsert(series);
    onSave(series);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>New metric series</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Label</Form.Label>
            <Form.Control autoFocus value={label} onChange={(e) => setLabel(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Value type</Form.Label>
            <Form.Select
              value={valueType}
              onChange={(e) => setValueType(e.target.value as "deci" | "int")}
            >
              {VALUE_TYPES.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" type="button" onClick={onHide}>
            Cancel
          </Button>
          <Button type="submit" disabled={!label.trim()}>
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
